import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const DEFAULT_VIEWBOX = "0 0 11 14";
const PrevPageIcon = ({ size, viewBox = DEFAULT_VIEWBOX, ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, viewBox, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11 12.1776L11 1.82064C11 1.03164 10.129 0.553642 9.463 0.976643L1.326 6.15464C0.708 6.54764 0.708 7.44864 1.326 7.84164L9.463 13.0216C10.129 13.4456 11 12.9666 11 12.1776Z",
      fill: rest.fill
    }
  ) });
};
export {
  PrevPageIcon
};
